import React, { Component, Fragment } from 'react';
import Navbar from '../components/Navbar';
import Breadcrumbs from '../components/Breadcrumbs';
import { ROUTES } from '../components/Router';
export default class Page extends Component {
  render() {
    var r = ROUTES;
    return (
      <Fragment>
        <title>PropertyHints: All Articles</title>
        <Navbar />

        <div id="features">
          <div className="container">
            <div className="row header">
              <div className="col-md-12" align="left">
                <Breadcrumbs crumbs={[{ url: '/all-articles', name: 'All Articles' }]} />
                <h2 className="lead text-center">
                  All Articles
                  <p style={{ fontSize: '11px' }}>21/11/2018</p>
                </h2>

                <hr />
                <div className="row">
                  <div className="col-sm-12 col-md-12">
                    {ROUTES.map(r => (
                      <div class="paper">
                        <a href={r.url}>{r.name || r.url}</a>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/AllArticles.jsx